import { SET_SMART_VALUE } from './constants';

const defaultState = {
    smartValue: 0,
};

const smart = (state = defaultState, action) => {
    switch (action.type) {
        case SET_SMART_VALUE:
            return { ...state, smartValue: action.smartValue };

        default:
            return state;
    }
};

export default smart;



// WEBPACK FOOTER //
// ./src/containers/common/smart/reducer.js